module.exports = __webpack_public_path__ + "img/jobs-selected-icon.1128f68f.svg";